export var source_content_section = { "uid": "source_content_section", "fields": { "title": { "defaultValue": "" }, "section_title": { "defaultValue": "" }, "anchor_title": { "defaultValue": "" } } };
